"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationAd',
  data: function data() {
    return {
      tab: 'plan',
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        submit: '提交',
        approve: '通过',
        reject: '拒绝',
        start: '投放',
        pause: '暂停',
        stop: '停止',
        complete: '完成',
        record: '记消耗'
      }[value] || value;
    },
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      var api = this.tab === 'plan' ? _decoration.decorationAdListApi : _decoration.decorationAdResultListApi;
      api(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    openCreate: function openCreate() {
      var _this2 = this;
      var start = new Date();
      var end = new Date(Date.now() + 7 * 86400000);
      var fmt = function fmt(d) {
        return "".concat(d.getFullYear(), "-").concat(String(d.getMonth() + 1).padStart(2, '0'), "-").concat(String(d.getDate()).padStart(2, '0'), " ").concat(String(d.getHours()).padStart(2, '0'), ":").concat(String(d.getMinutes()).padStart(2, '0'), ":00");
      };
      this.$prompt('计划名称', '我要投流').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationAdSaveApi)({
          name: value || '本周留资宝',
          planType: 'lead',
          budgetAmount: 200,
          startTime: fmt(start),
          endTime: fmt(end),
          creativeType: 'store'
        }).then(function () {
          _this2.$message.success('计划已创建');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    runAction: function runAction(row, action) {
      var _this3 = this;
      var payload = {
        action: action
      };
      var exec = function exec(amount) {
        if (action === 'record') {
          payload.eventType = 'charge';
          payload.chargeAmount = Number(amount || 20);
        }
        (0, _decoration.decorationAdActionApi)(row.plan.id, payload).then(function () {
          _this3.$message.success('投流已更新');
          _this3.loadCurrent();
        });
      };
      if (action === 'record') {
        this.$prompt('消耗金额', '记消耗').then(function (_ref2) {
          var value = _ref2.value;
          return exec(value);
        }).catch(function () {});
      } else {
        this.$confirm("\u786E\u8BA4".concat(this.actionText(action), "\uFF1F")).then(function () {
          return exec();
        }).catch(function () {});
      }
    }
  }
};